import * as React from 'react';
import React__default from 'react';
import { u as useEnhancedEffect } from './useEnhancedEffect-22d6b63a.js';

/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */

function useEventCallback(fn) {
  const ref = React.useRef(fn);
  useEnhancedEffect(() => {
    ref.current = fn;
  });
  return React.useCallback((...args) =>
  // @ts-expect-error hide `this`
  // tslint:disable-next-line:ban-comma-operator
  (0, ref.current)(...args), []);
}

var TransitionGroupContext = React__default.createContext(null);

export { TransitionGroupContext as T, useEventCallback as u };
//# sourceMappingURL=TransitionGroupContext-42c2fd98.js.map
